var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrownGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_420_3265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5671 11.6214C24.3279 11.2071 23.73 11.2071 23.4908 11.6214L7.68378 39C7.44462 39.4143 7.74357 39.9321 8.22189 39.9321H19.3226L8.68336 50.4811C8.28936 50.8718 8.56601 51.5437 9.12086 51.5437H40.2123C40.5324 51.5437 40.8001 51.3005 40.8308 50.9818L44.1074 16.9051C44.163 16.3263 43.4643 15.995 43.0514 16.4044L33.0525 26.3185L24.5671 11.6214Z",
    fill: "#BF811D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20332 16.905C4.14767 16.3263 4.84643 15.995 5.25933 16.4043L39.6273 50.4811C40.0213 50.8718 39.7447 51.5437 39.1898 51.5437H8.09844C7.77831 51.5437 7.51058 51.3005 7.47994 50.9818L4.20332 16.905Z",
    fill: "#EFA936"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9999,
    cy: 5.6408,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#BF811D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.18447,
    cy: 10.301,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#EFA936"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.8156,
    cy: 10.301,
    rx: 3.18447,
    ry: 3.18447,
    fill: "#BF811D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_420_3265",
    x: 0,
    y: 0.456314,
    width: 48,
    height: 51.0874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.231373 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_3265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420_3265",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownGold);
export default __webpack_public_path__ + "static/media/crown_gold.75e6d1aa1d2eafdeb8112f00a168f31d.svg";
export { ForwardRef as ReactComponent };